//import logo from './logo.svg';
//import './App.css';
import React, {useEffect,useState} from 'react';
import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Button from '@mui/material/Button';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import { mainListItems, secondaryListItems } from './listItems';
import Stack from '@mui/material/Stack';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, Map, MapControl } from 'react-leaflet'
import {getPublicProject, getProjects,getProject} from './features/projects/projectSlice'
import Card from '@mui/material/Card';
import Moment from 'moment'

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import UserList from './userList';
import Odors from './odorTracker';
import MapDevice from './mapDevice';
import LeafMap from './leafMap';
import Legend from './Legend';
import logo from './logos/JustAirLogo1.png'
import raccelogo from './logos/raccelogo1.jpg'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {useDispatch, useSelector} from 'react-redux'
import {getDevices} from './features/devices/deviceSlice'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";

//import memories from './memories.png'
import { logout, reset } from './features/auth/authSlice'


import useStyles from './styles'

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#29ABE2',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});


const App = () => {


 const dispatch = useDispatch();
 const navigate = useNavigate();


 const { user } = useSelector((state) => state.auth)
 const { publicProject, projects } = useSelector((state) => state.project)

 const [dataLength, setDataLength] = useState({ })


  useEffect(() => {
    dispatch(getDevices());
    dispatch(getProjects());



  }, [navigate, dispatch,devices]);


  const { devices, isLoading, isError, message } = useSelector(
     (state) => state.device
   )

  if (publicProject.deviceProject){

    var measures = publicProject.deviceProject[0].deviceMeasures
    console.log(measures)

  }
/*
if(publicProject.deviceProject[publicProject.deviceProject.length/2]){
  console.log(publicProject.deviceProject[publicProject.deviceProject.length/2])

}

*/

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/" target="_blank">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));



const mdTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#5A2483',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});;


  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };


    var colorMarker = function (p){
      var no2 = p.no2.pi
      var voc = p.voc.pi
      var pm25 = p.pm25.pi

      var max_val = 0;

          if (no2 > voc)
          {
            max_val = no2;
          } else
          {
            max_val = voc;
          }
          if (pm25 > max_val)
          {
            max_val = pm25;
          }


      if (max_val>100.0){
        return { color: 'purple' };
      } else if (max_val>=100.0){
        return { color: 'purple' };
      }else if (max_val>=51.0){
        return { color: 'red' };
      }else if (max_val>=20.0){
        return { color: 'yellow' };
      }else{
        return { color: '#22b573' };
      }
    }


  const onLogout = () => {
    dispatch(logout())
    dispatch(reset())
    navigate('/')

  }

  const projectNav = (p) => {

    dispatch(getPublicProject(p));
    navigate('/publicProject')

  }

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >

            <Typography
              component="h1"
              variant="h6"
              color="white"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              R.A.C.C.E Mobile Air
            </Typography>

            {user ? (<>
            <Button color="inherit"   onClick={() => { onLogout()}}>Logout</Button></>
              ) :
              (<>
              <Button color="inherit"   onClick={() => { navigate("/login");}}>Login</Button>
              <Button color="inherit"  onClick={() => { navigate("/register");}}>Register</Button> </>)
            }


          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />



            <Container maxWidth="lg">
            <Grid container  spacing={0} direction="row"  alignItems="center" justifyContent="center"  >

              <Grid item alignItems="center" justifyContent="center"  xs={12} md={12} lg={12}>
              <Box
                   component="img"

                    width="50%"
                   sx={{ border: 'none' }}
                    src={raccelogo}
                  />

                  <Card sx={{ height:1,padding: 2,borderRadius: '16px' }}>
                                   <CardContent >
                                   <Typography variant="h4" component="div" >


                                     </Typography>
                                     <Typography variant="h5" component="div">
                                     This project intends to assist, guide, and report out hyper-local air quality monitoring results in neighborhoods and schools communities across the city of Waterbury.

                                     </Typography>


                                     <Typography variant="h5" component="div">

                                     </Typography>



                                   </CardContent>

                                 </Card>

              </Grid>

              {projects.map( ( p ) => (
                            <Grid item sx={{ m: 1 }} xs={12} md={4} lg={4}>

                              <Card key={p._id} sx={{ height:1 ,padding: 2,borderRadius: '16px',bgcolor: '#E5E4E2' }}>
                                 <CardContent >
                                 <Typography variant="h5" component="div" >
                                  {p.projectName}
                                   </Typography>


                                   <Typography variant="h6" component="div">
                                  {p.orgName}
                                   </Typography>

                                   <Typography variant="h6" component="div">

                                   {Moment(p.startDate).format('MM/DD/YYYY')}
                                   </Typography>



                                 </CardContent>
                                 <CardActions>
                                   <Button size="small" variant="contained" sx={{ bgcolor: '#af8dbf' }} onClick={() => {

                                      projectNav(p)
                                    }}>View Project</Button>


                                 </CardActions>
                               </Card>
                          </Grid>
                            ))}


           </Grid>

           </Container>

        </Box>
      </Box>
    </ThemeProvider>
  );



}


export default App;
